export default __webpack_public_path__ + "static/media/BV_image1.0fdf790c.jpg";